export const authenticationErrors = {
  userIdIsNotSet: `User ID isn't set for Session`,
  portalNotConnected: 'Portal not connected',
  sessionNotFound: 'Session not found',
  cookieNotFound: 'Any of the listed authentication credentials are missing',
  noPortalInUrl: 'Unable to deduce portalId from this request'
};
export const AUTH_ERROR_SUB_CATEGORY = 'AuthError';